<template>  
  <div class="modal-card modal-card--modern modal-card--md">
    <div class="auth-modal-wrapper">
      <header class="modal-card-head">
        <p class="modal-card-title">
          Sign In
        </p>
      
        <a class="close-modal" aria-label="close" @click="closeModal()">
          <i class="material-icons">close</i>
        </a>
      </header>
      <section class="modal-card-body">

        <p>
          To continue, please enter your company email address
        </p>

        <div class="input-container with-left-icon"
          :class="{'input-container--error' : error}"
        >
          <span class="icon icon-email-action-unread"></span>
          <input type="email" autocomplete="email" placeholder="name@example.com" v-model="email">
        </div>
        <span class="error-message is-small-text error-message--after-input-container" v-if="error">
          {{ error }}
        </span>
        
      
        <div class="flexbox-center button-row">
          <button class="button button-medium button-secondary" 
            @click="next()"
          >
            <div class="labs-loader" v-if="emailLoading"></div>
            Next
          </button>
        </div>

        <div class="modal-footer-note is-small-text">
          <!-- Don't have an account yet? <span class="pseudo-link pseudo-link--secondary" @click="signUpPage()">Sign Up</span> -->
        </div>
        
      </section>
    </div>
  </div>
</template>

<script lang="ts">
declare var AuthBar: any;
// import acceleratorApi from '@/api/accelerator.api';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
// import HelperService from '@/services/helpers.service';
import Env from '@/services/env.service';

@Component({
  components: {
  },
})
export default class SignInEmail extends Vue {
  public error: string = '';
  public valid: boolean = false;
  public email: string = '';
  public emailLoading: boolean = false;
  public emailTimeout: any;

  @Watch('email')
  public onPropertyChanged(value: string, oldValue: string) {
    this.error = '';
    localStorage.setItem('signInEmail', value);
  }

  public closeModal() {
    this.$store.commit('setModal', '');
  }

  public signUpPage() {
    this.$store.commit('setModal', 'auth_signUpEmail');
  }

  public keyUpListener(e: any) {
    if (e.keyCode === 13) {
      this.next();
    }
  }

  public async next() {
    this.error = '';
    this.emailLoading = true;

    if (this.isEmailValid(this.email)) {
       console.log(Env.get("VUE_APP_AUTH_BACK_URL") + "/login");
        location.href = Env.get("VUE_APP_AUTH_BACK_URL") + "/login";    
    } else {
      this.error = 'Please enter a valid email address';
      this.emailLoading = false;
    }
   
  }
  isEmailValid(email?: string) {
    let valid = true;

    if (!email || !email.length) {
      valid = false;
    } else if (email.indexOf('@') === -1) {
      valid = false;
    }

    return valid;
  }


  public mounted() {
    // this.$store.commit('setAuthFlowEmail', undefined);
    this.email = localStorage.getItem('signInEmail') || '';
    window.addEventListener('keyup', this.keyUpListener)
  }

  public destroyed() {
    window.removeEventListener('keyup', this.keyUpListener)
  }
}

</script>

<style scoped lang="scss">
@import '@/scss/partials/_settings.colors.scss';
  .modal-card--modern {
    p {
      max-width: 500px;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .input-container {
    i {
      color: $grey-200;
    }
  }

  .icon-email-action-unread {
    top: 13px !important;
  }
 .button {
  position: relative;
  z-index: 0;
  overflow: hidden;
  border-width: 2px;
 }
   .button::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: -1px;
    left: 0;
    right: 0;
    background-color: #fff;
    -webkit-transform: translateY(101%);
            transform: translateY(101%);
    transition: -webkit-transform 200ms ease;
    transition: transform 200ms ease;
    transition: transform 200ms ease, -webkit-transform 200ms ease;
    z-index: -1; }
</style>